import { useState, ChangeEvent } from "react";
import { TablePaginationConfig } from "antd";
import { useNavigate } from "react-router-dom";

interface PayloadType {
  discountType: "Order" | "Product" | string;
  discountName: string;
  description: string;
  startDate: string;
  endDate: string;
  percentageOff: string;
  minimumOrderAmount: string;
  maxDiscountAmount: string;
}

export const useDiscountHelper = () => {
  const navigate = useNavigate();

  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (newPagination: TablePaginationConfig) => {
    setPagination((prev) => ({
      ...prev,
      current: newPagination.current ?? 1,
      pageSize: newPagination.pageSize ?? 10,
    }));
  };

  const [payload, setPayload] = useState<PayloadType>({
    discountType: "",
    discountName: "",
    description: "",
    startDate: "",
    endDate: "",
    percentageOff: "",
    minimumOrderAmount: "",
    maxDiscountAmount: "",
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };

  return {
    payload,
    pagination,
    rowSelection,
    navigate,
    setPayload,
    handleTableChange,
    handleInputChange,
  };
};
